import React from 'react';
import AdminTopBar from './AdminTopBar';
import { MailIcon, MapIcon, GlobeAltIcon, PhoneIcon } from "@heroicons/react/outline"; // Import the icons

const Support = () => {
  return (
    <>
      <AdminTopBar title="Support Information" />

      <div className="container mx-auto p-6 space-y-6">
        {/* STI Contact Details Section */}
        <div className="bg-white border border-gray-300  p-6">
          <h2 className="text-2xl font-bold mb-4 text-custom-blue-1">Contact Us</h2>

          <div className="text-gray-700 space-y-4">
            <p className="flex items-center">
              <MailIcon className="h-5 w-5 text-gray-500 mr-2" />
              <span className="font-semibold">Email:</span> 
              <a href="mailto:grants@sti.go.ug" className="text-blue-500 hover:underline ml-2"> joshuaisiko@gmail.com</a>
            </p>
            <p className="flex items-center">
              <MailIcon className="h-5 w-5 text-gray-500 mr-2" />
              <span className="font-semibold">Email:</span> 
              <a href="mailto:grants@sti.go.ug" className="text-blue-500 hover:underline ml-2"> mugenimathias99@gmail.com</a>
            </p>
            <p className="flex items-center">
              <MapIcon className="h-5 w-5 text-gray-500 mr-2" />
              <span className="font-semibold">Address:</span> 
              <span className="ml-2">STI-OP Office, Plot 106 Katalima Road, Naguru</span>
            </p>
            <p className="flex items-center">
              <GlobeAltIcon className="h-5 w-5 text-gray-500 mr-2" />
              <span className="font-semibold">Website:</span> 
              <a href="https://www.sti.go.ug" className="text-blue-500 hover:underline ml-2">www.sti.go.ug</a>
            </p>
                {/* Phone Numbers */}
    <p className="flex items-center">
      <PhoneIcon className="h-5 w-5 text-gray-500 mr-2" />
      <span className="font-semibold">Phone:</span>
      <span className="ml-2">+256754840465, +25678274778</span>
    </p>
    <p className="flex items-center">
      <PhoneIcon className="h-5 w-5 text-gray-500 mr-2" />
      <span className="font-semibold">Phone:</span>
      <span className="ml-2">+256744439356, +256752707329</span>
    </p>
          </div>

          {/* Social Media Section */}
          <div className="mt-8">
            <h3 className="text-xl font-semibold">Follow Us</h3>
            <p className="text-gray-700">Stay connected for updates</p>
            <p>
              <a href="https://x.com/STIsecretariat" className="text-blue-500 hover:underline">x.com/STIsecretariat</a>
            </p>
          </div>
        </div>

       </div>
    </>
  );
};

export default Support;
